import React from 'react';

export const MagicStarsSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="99"
    height="92"
    viewBox="0 0 99 92"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.2139 18.451C15.622 15.3867 16.3081 2.56534 16.3081 2.56534C16.3081 2.56534 16.3081 14.5205 20.2386 18.451C23.5175 21.73 31.101 21.2302 32.5918 21.0966C32.7584 21.079 32.8489 21.0713 32.8489 21.0713C32.8489 21.0713 32.7584 21.0817 32.5918 21.0966C31.114 21.253 23.6461 22.1963 20.2386 25.575C16.447 29.3345 16.3081 42.1977 16.3081 42.1977C16.3081 42.1977 15.8987 29.9968 12.2139 25.575C9.46932 22.2816 3.57308 21.3855 1.11953 21.1509C0.429262 21.1183 0.0130157 21.0713 0.0130157 21.0713C0.0130157 21.0713 0.43053 21.0851 1.11953 21.1509C3.50245 21.2635 9.15103 21.2049 12.2139 18.451Z"
      fill="#FDDA5D"
    />
    <path
      d="M51.5681 36.2923C59.2818 29.3568 60.8348 0.337677 60.8348 0.337677C60.8348 0.337677 60.8348 27.3963 69.7308 36.2923C77.1522 43.7138 94.3162 42.5824 97.6904 42.2802C98.0673 42.2403 98.2721 42.223 98.2721 42.223C98.2721 42.223 98.0673 42.2464 97.6904 42.2802C94.3457 42.6342 77.4432 44.7691 69.7308 52.4163C61.1491 60.9254 60.8348 90.039 60.8348 90.039C60.8348 90.039 59.9081 62.4243 51.5681 52.4163C45.3563 44.9621 32.0111 42.9341 26.4578 42.4032C24.8955 42.3293 23.9534 42.223 23.9534 42.223C23.9534 42.223 24.8984 42.2541 26.4578 42.4032C31.8512 42.658 44.6359 42.5253 51.5681 36.2923Z"
      fill="#FDDA5D"
    />
    <path
      d="M25.8402 68.2031C29.2483 65.1388 29.9345 52.3174 29.9345 52.3174C29.9345 52.3174 29.9345 64.2727 33.865 68.2031C37.1439 71.4821 44.7274 70.9823 46.2182 70.8487C46.3848 70.8311 46.4753 70.8234 46.4753 70.8234C46.4753 70.8234 46.3847 70.8338 46.2182 70.8487C44.7403 71.0051 37.2725 71.9484 33.865 75.3271C30.0734 79.0866 29.9345 91.9498 29.9345 91.9498C29.9345 91.9498 29.5251 79.7489 25.8402 75.3271C23.0957 72.0337 17.1995 71.1376 14.7459 70.903C14.0556 70.8704 13.6394 70.8234 13.6394 70.8234C13.6394 70.8234 14.0569 70.8372 14.7459 70.903C17.1288 71.0156 22.7774 70.957 25.8402 68.2031Z"
      fill="#FDDA5D"
    />
  </svg>
);

export default MagicStarsSvg;
